var _namedview, _g, _g2, _g3, _g4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco427Template = function SvgFefco427Template(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283.5mm",
    height: "332.2mm",
    viewBox: "-91.8 -5.0 283.5 332.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width",
    display: "inline",
    transform: "matrix(1.0621953,0,0,0.99988317,-1.7219676,-10.992792)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 96,
    y1: 60.700001,
    y2: 60.700001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 92,
    y1: 60.700001,
    y2: 59.700001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 92,
    y1: 60.700001,
    y2: 61.700001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 8,
    y1: 60.700001,
    y2: 59.700001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 8,
    y1: 60.700001,
    y2: 61.700001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 50.572121,
    y: 58.948837,
    fill: "#000",
    fontSize: "5.64444447px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 105,
    x2: 105,
    y1: 38.200001,
    y2: 148.2,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    x2: 104,
    y1: 38.200001,
    y2: 42.200001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    x2: 106,
    y1: 38.200001,
    y2: 42.200001,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    x2: 104,
    y1: 148.2,
    y2: 144.2,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    x2: 106,
    y1: 148.2,
    y2: 144.2,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 95.199997,
    fill: "#000",
    fontSize: "5.64444447px",
    textAnchor: "middle",
    transform: "rotate(-90,110,95.199998)"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    display: "inline",
    transform: "rotate(90,-21.720834,21.720834)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.1999998,
    x2: 6.1999998,
    y1: 0,
    y2: 39,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1999998,
    x2: 5.1999998,
    y1: 0,
    y2: 4,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1999998,
    x2: 7.1999998,
    y1: 0,
    y2: 4,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1999998,
    x2: 5.1999998,
    y1: 39,
    y2: 35,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1999998,
    x2: 7.1999998,
    y1: 39,
    y2: 35,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 11.2,
    y: 21.5,
    fill: "#000",
    fontSize: "5.64444447px",
    textAnchor: "middle",
    transform: "rotate(-90,11.199999,21.5)"
  }, "\n            Height\n        "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m 114.2,195.2 q 8.25,3 8.3,10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m 122.5,274.2 q 0,7.5 -8.3,10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m -14.3,195.2 q -8.25,3 -8.2,10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m -22.5,274.2 q 0,7.5 8.2,10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m -10.5,294.7 q -12,0 -14.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m -25,302.7 q 0,11.5 29.5,19.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m 110.5,294.7 q 12,0 14.5,8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m 125,302.7 q 0,11.5 -29.5,19.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 3.5,
    y1: 38.200001,
    y2: 39,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    x2: 96.5,
    y1: 39,
    y2: 39.200001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 96.5,
    y1: 38.200001,
    y2: 39.200001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 100,
    y1: 38.200001,
    y2: 148.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    x2: 100,
    y1: 147.2,
    y2: 148.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    x2: 96.5,
    y1: 147.2,
    y2: 147.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 3.5,
    y1: 148.2,
    y2: 147.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 38.200001,
    y2: 148.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 4,
    y1: 50.700001,
    y2: 50.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 4,
    y1: 50.700001,
    y2: 69.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 4,
    y1: 69.5,
    y2: 69.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 4,
    y1: 116.9,
    y2: 116.9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 4,
    y1: 116.9,
    y2: 135.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 4,
    y1: 135.7,
    y2: 135.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5,
    x2: 0,
    y1: 38,
    y2: 38,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44,
    x2: -39.5,
    y1: 40.5,
    y2: 38,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -44,
    y1: 40.5,
    y2: 40.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -81.5,
    y1: 40.5,
    y2: 50.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -86.800003,
    y1: 50.700001,
    y2: 51.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -86.800003,
    x2: -86.800003,
    y1: 51.700001,
    y2: 68.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -86.800003,
    y1: 69.5,
    y2: 68.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -81.5,
    y1: 69.5,
    y2: 116.9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -86.800003,
    y1: 116.9,
    y2: 117.9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -86.800003,
    x2: -86.800003,
    y1: 117.9,
    y2: 134.60001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -86.800003,
    x2: -81.5,
    y1: 134.60001,
    y2: 135.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -81.5,
    y1: 135.7,
    y2: 145.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -81.5,
    x2: -44,
    y1: 145.7,
    y2: 145.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44,
    x2: -39.5,
    y1: 145.7,
    y2: 148.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5,
    x2: 0,
    y1: 148.2,
    y2: 148.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5,
    x2: -39.5,
    y1: 38,
    y2: 148.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44,
    x2: -44,
    y1: 40.5,
    y2: 145.7,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 1.3,
    y2: 38,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 100,
    y1: 1.3,
    y2: 38.200001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.2,
    x2: 98.699997,
    y1: 0,
    y2: 0,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.2,
    x2: -1.3,
    y1: 0,
    y2: 1.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.699997,
    x2: 101.2,
    y1: 0,
    y2: 1.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: -1.3,
    y1: 1.5,
    y2: 1.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.2,
    x2: 147.5,
    y1: 1.5,
    y2: 1.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: -47.5,
    y1: 1.5,
    y2: 38,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.5,
    x2: 147.5,
    y1: 1.5,
    y2: 38.200001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 100,
    y1: 50.700001,
    y2: 50.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 96,
    y1: 50.700001,
    y2: 69.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 100,
    y1: 69.5,
    y2: 69.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 100,
    y1: 116.9,
    y2: 116.9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 96,
    y1: 116.9,
    y2: 135.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    x2: 100,
    y1: 135.7,
    y2: 135.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 139.5,
    y1: 38.200001,
    y2: 38.200001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    x2: 144,
    y1: 38.200001,
    y2: 40.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    x2: 181.5,
    y1: 40.700001,
    y2: 40.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    x2: 181.5,
    y1: 40.700001,
    y2: 50.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    x2: 186.7,
    y1: 50.700001,
    y2: 51.700001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.7,
    x2: 186.7,
    y1: 51.700001,
    y2: 68.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.7,
    x2: 181.5,
    y1: 68.5,
    y2: 69.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    x2: 181.5,
    y1: 69.5,
    y2: 116.9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    x2: 186.7,
    y1: 116.9,
    y2: 117.9,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.7,
    x2: 186.7,
    y1: 117.9,
    y2: 134.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    x2: 186.7,
    y1: 135.7,
    y2: 134.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5,
    x2: 181.5,
    y1: 135.7,
    y2: 145.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    x2: 181.5,
    y1: 145.7,
    y2: 145.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    x2: 144,
    y1: 148.2,
    y2: 145.7,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 139.5,
    y1: 148.2,
    y2: 148.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    x2: 139.5,
    y1: 38.200001,
    y2: 148.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    x2: 144,
    y1: 40.700001,
    y2: 145.7,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: -39.5,
    y1: 38,
    y2: 38,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    x2: 147.5,
    y1: 38.200001,
    y2: 38.200001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: -39.5,
    y1: 148.2,
    y2: 148.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    x2: 147.5,
    y1: 148.2,
    y2: 148.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    x2: 3.5,
    y1: 147.2,
    y2: 184.60001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    x2: 7.5,
    y1: 184.60001,
    y2: 187.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 92.5,
    y1: 187.2,
    y2: 187.2,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    x2: 92.5,
    y1: 184.60001,
    y2: 187.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    x2: 96.5,
    y1: 147.2,
    y2: 184.60001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: 3.5,
    y1: 184.60001,
    y2: 184.60001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: -47.5,
    y1: 148.2,
    y2: 184.60001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    x2: 147.5,
    y1: 184.60001,
    y2: 184.60001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.5,
    x2: 147.5,
    y1: 148.2,
    y2: 184.60001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 7.5,
    y1: 187.2,
    y2: 189.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 7.5,
    y1: 189.2,
    y2: 290.20001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 7.5,
    y1: 290.20001,
    y2: 292.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 92.5,
    y1: 292.20001,
    y2: 292.20001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    x2: 92.5,
    y1: 290.20001,
    y2: 292.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    x2: 92.5,
    y1: 189.2,
    y2: 290.20001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    x2: 92.5,
    y1: 187.2,
    y2: 189.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    x2: 114.2,
    y1: 189.2,
    y2: 195.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.2,
    x2: 92.5,
    y1: 284.20001,
    y2: 290.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.5,
    x2: 122.5,
    y1: 205.2,
    y2: 274.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -14.3,
    x2: 7.5,
    y1: 195.2,
    y2: 189.2,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -14.3,
    x2: 7.5,
    y1: 284.20001,
    y2: 290.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22.5,
    x2: -22.5,
    y1: 205.2,
    y2: 274.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    x2: 7.5,
    y1: 294.70001,
    y2: 292.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    x2: 4.5,
    y1: 294.70001,
    y2: 322.20001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    x2: 95.5,
    y1: 322.20001,
    y2: 322.20001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.5,
    x2: 95.5,
    y1: 294.70001,
    y2: 322.20001,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.5,
    x2: 95.5,
    y1: 292.20001,
    y2: 294.70001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.5,
    x2: 110.5,
    y1: 294.70001,
    y2: 294.70001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.5,
    x2: 4.5,
    y1: 294.70001,
    y2: 294.70001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -47.5,
    x2: -47.5,
    y1: 33,
    y2: 38,
    stroke: "#000",
    strokeDasharray: "1010,2,5",
    strokeWidth: 0.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco427Template, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-427-template.1bd8e951.svg";
export { ForwardRef as ReactComponent };